type RemoveEventError = {
  notFound: boolean;
};

const removeEventError: RemoveEventError = {
  notFound: false,
};

export type { RemoveEventError };

export { removeEventError };
